import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ListSubheader,
  List,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BrunchDiningIcon from '@mui/icons-material/BrunchDining';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TocOutlinedIcon from '@mui/icons-material/TocOutlined';
import AppsOutageOutlinedIcon from '@mui/icons-material/AppsOutageOutlined';
import {
  MY_BATCHES,
  RECIPES,
  BASE_RECIPES,
  CHEF_SUGGESTED_BATCHES,
  MY_SPACE,
  PREFERENCES,
  OUR_SUGGESTIONS
} from "../../../../routes";
import SubMenuWrapper from "./SubMenuWrapper";
import MenuWrapper from "./MenuWrapper";
import UserContext from "../../../../hooks/UserContext";

function SidebarMenu() {
  const { t } = useTranslation();
  const { closeSidebar } = useContext(SidebarContext);
  const { user } = useContext(UserContext)
  return (
    <MenuWrapper>
      <List component="div">
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to="/"
                startIcon={<HomeIcon />}
              >
                {t('navigation.home')}
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={RECIPES}
                startIcon={<BrunchDiningIcon />}
              >
                {t('navigation.recipes')}
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={OUR_SUGGESTIONS}
                startIcon={<CalendarMonthIcon />}
              >
                {t('navigation.batches')}
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>
      {user && !user.roles.includes("public") && (
        <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            {t('navigation.mySpace')}
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={MY_SPACE}
                startIcon={<CalendarTodayIcon />}
              >
                {t('navigation.myCurrentBatch')}
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={MY_BATCHES}
                startIcon={<AppRegistrationIcon />}
              >
                {t('navigation.myBatches')}
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>)}
      {user?.roles?.includes('creator') && <List
        component="div"
        subheader={
          <ListSubheader component="div" disableSticky>
            {t('navigation.chefSpace')}
          </ListSubheader>
        }
      >
        <SubMenuWrapper>
          <List component="div">
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={BASE_RECIPES}
                startIcon={<TocOutlinedIcon />}
              >
                {t('navigation.baseRecipes')}
              </Button>
            </ListItem>
            <ListItem component="div">
              <Button
                disableRipple
                component={RouterLink}
                onClick={closeSidebar}
                to={CHEF_SUGGESTED_BATCHES}
                startIcon={<AppsOutageOutlinedIcon />}
              >
                {t('navigation.chefBatches')}
              </Button>
            </ListItem>
          </List>
        </SubMenuWrapper>
      </List>}
      {/*{user && !user.roles.includes("public") && (<List*/}
      {/*  component="div"*/}
      {/*  subheader={*/}
      {/*    <ListSubheader component="div" disableSticky>*/}
      {/*      Profil utilisateur & Préférences*/}
      {/*    </ListSubheader>*/}
      {/*  }*/}
      {/*>*/}
      {/*  <SubMenuWrapper>*/}
      {/*    <List component="div">*/}
      {/*      /!*<ListItem component="div">*!/*/}
      {/*      /!*  <Button*!/*/}
      {/*      /!*    disableRipple*!/*/}
      {/*      /!*    component={RouterLink}*!/*/}
      {/*      /!*    onClick={closeSidebar}*!/*/}
      {/*      /!*    to="/"*!/*/}
      {/*      /!*  >*!/*/}
      {/*      /!*    Mon Profil*!/*/}
      {/*      /!*  </Button>*!/*/}
      {/*      /!*</ListItem>*!/*/}
      {/*      <ListItem component="div">*/}
      {/*        <Button*/}
      {/*          disableRipple*/}
      {/*          component={RouterLink}*/}
      {/*          onClick={closeSidebar}*/}
      {/*          to={PREFERENCES}*/}
      {/*        >*/}
      {/*          Mes préférences*/}
      {/*        </Button>*/}
      {/*      </ListItem>*/}
      {/*    </List>*/}
      {/*  </SubMenuWrapper>*/}
      {/*</List>)}*/}
    </MenuWrapper>
  );
}

export default SidebarMenu;
